import React from 'react';
import { Search, HelpCircle, AlertTriangle, User, Settings, MessageSquare } from 'lucide-react';

const Support = () => {
    const categories = [
        { icon: <AlertTriangle size={24} />, title: "Reportes", desc: "Cómo crear, editar y seguir tus reportes." },
        { icon: <User size={24} />, title: "Mi Cuenta", desc: "Gestionar perfil, contraseña y privacidad." },
        { icon: <Settings size={24} />, title: "Configuración", desc: "Notificaciones, idioma y preferencias." },
        { icon: <MessageSquare size={24} />, title: "Comunidad", desc: "Normas de convivencia y puntos de karma." },
    ];

    const faqs = [
        "¿Cómo cambio mi ubicación en el mapa?",
        "¿Qué hago si mi reporte fue rechazado?",
        "¿Cómo puedo contactar a mi municipalidad?",
        "¿Es anónimo mi reporte?",
        "¿Cómo ganar puntos de reputación?"
    ];

    return (
        <div className="min-h-screen bg-white font-roboto text-slate-900">
            {/* Search Hero */}
            <div className="bg-hue-light-blue py-20 px-6 text-center rounded-b-[3rem]">
                <h1 className="text-4xl md:text-5xl font-bold mb-8 text-hue-purple">¿Cómo podemos ayudarte?</h1>
                <div className="max-w-2xl mx-auto relative">
                    <input
                        type="text"
                        placeholder="Describe tu problema..."
                        className="w-full p-6 pl-16 rounded-full shadow-xl border-0 focus:ring-4 focus:ring-hue-purple/20 text-lg"
                    />
                    <Search className="absolute left-6 top-1/2 -translate-y-1/2 text-slate-400" size={28} />
                </div>
            </div>

            {/* Categories Grid */}
            <div className="max-w-5xl mx-auto px-6 py-16">
                <h2 className="text-2xl font-bold mb-8 text-center">Explorar por temas</h2>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {categories.map((cat, idx) => (
                        <div key={idx} className="p-6 rounded-2xl border border-slate-100 hover:shadow-lg hover:border-hue-purple/30 transition cursor-pointer group bg-white">
                            <div className="w-12 h-12 rounded-full bg-slate-50 group-hover:bg-hue-light-blue flex items-center justify-center text-slate-600 group-hover:text-hue-purple mb-4 transition">
                                {cat.icon}
                            </div>
                            <h3 className="font-bold text-lg mb-2">{cat.title}</h3>
                            <p className="text-sm text-slate-500">{cat.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Popular FAQs */}
            <div className="bg-slate-50 py-16 px-6 rounded-[3rem] mx-4 mb-20">
                <div className="max-w-3xl mx-auto">
                    <h2 className="text-2xl font-bold mb-8 text-center">Preguntas frecuentes</h2>
                    <div className="space-y-4">
                        {faqs.map((faq, idx) => (
                            <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-md transition cursor-pointer flex justify-between items-center">
                                <span className="font-medium text-slate-700">{faq}</span>
                                <HelpCircle size={20} className="text-hue-purple opacity-50" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;
